import React from 'react';
import { Route, Link } from 'react-router-dom';
import Pagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';

export default function CommonPagination({ baseUrl, totalPages }) {
  if (baseUrl === undefined || totalPages === undefined) return null;
  return (
    <Route>
      {({ location }) => {
        const query = new URLSearchParams(location.search);
        const page = parseInt(query.get('page') || '1', 10);
        return (
          <Pagination
            className="pagination justify-content-center"
            page={page}
            count={totalPages}
            shape="rounded"
            color="primary"
            renderItem={(item) => (
              <PaginationItem
                component={Link}
                to={`/${baseUrl}${`?page=${item.page}`}`}
                {...item}
              />
            )}
          />
        );
      }}
    </Route>
  );
}
